var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',[_c('v-card-text',{staticClass:"pt-0"},[_c('BranchOffices',{on:{"selectBranch":_vm.selectBranch}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }